<template>
    <v-dialog :value="dialog" @click:outside="closeDialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card class="review-form-modal px-sm-8 py-6">
            <div class="modal-close-btn" style="position: absolute; top: 10px; right: 10px;">
                <v-btn icon @click="closeDialog">
                    <v-icon size="24" color="grey">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-title class="d-flex justify-center pb-4">
                <span class="text-h6">Write a Review</span>
            </v-card-title>

            <v-card-subtitle class="text-center pb-4" v-if="propertyName">
                {{ propertyName }}
            </v-card-subtitle>

            <v-card-text>
                <form @submit.prevent="submit">
                    <v-row class="mb-4">
                        <v-col cols="12" class="text-center">
                            <p class="mb-2 font-weight-medium">Overall Rating</p>
                            <RatingStars
                                :value="rating"
                                @input="rating = $event"
                                :readonly="false"
                                :size="42"
                            />
                            <p v-if="ratingError" class="error--text caption mt-1">
                                Please select a rating
                            </p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="reviewText"
                                label="Your Review"
                                outlined
                                rows="5"
                                counter="5000"
                                :error-messages="reviewTextErrors"
                                @blur="touchReviewText"
                                placeholder="Share your experience living at this property. What did you like? What could be improved? (minimum 50 characters)"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                depressed
                                block
                                height="45"
                                class="btn-edurent"
                                :loading="isSubmitting"
                                :disabled="!isFormValid"
                                @click="submit"
                            >
                                Submit Review
                            </v-btn>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import RatingStars from '../RatingStars.vue';

export default {
    name: 'ReviewForm',
    components: {
        RatingStars
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        propertyName: {
            type: String,
            default: ''
        },
        propertyId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            rating: 0,
            reviewText: '',
            ratingTouched: false,
            reviewTextTouched: false
        }
    },
    computed: {
        isSubmitting() {
            return this.$store.getters.isSubmittingReview;
        },
        ratingError() {
            return this.ratingTouched && this.rating === 0;
        },
        reviewTextErrors() {
            const errors = [];
            if (this.reviewTextTouched) {
                if (!this.reviewText) {
                    errors.push('Please provide a review');
                } else if (this.reviewText.length < 50) {
                    errors.push('Review must be at least 50 characters');
                } else if (this.reviewText.length > 5000) {
                    errors.push('Review cannot exceed 5000 characters');
                }
            }
            return errors;
        },
        isFormValid() {
            return this.rating > 0 && this.reviewText.length >= 50 && this.reviewText.length <= 5000;
        }
    },
    methods: {
        closeDialog() {
            this.$store.dispatch('setReviewFormModal', false);
            this.resetForm();
        },
        touchReviewText() {
            this.reviewTextTouched = true;
        },
        resetForm() {
            this.rating = 0;
            this.reviewText = '';
            this.ratingTouched = false;
            this.reviewTextTouched = false;
        },
        async submit() {
            this.ratingTouched = true;
            this.reviewTextTouched = true;

            if (!this.isFormValid) {
                return;
            }

            await this.$store.dispatch('submitReview', {
                propertyId: this.propertyId,
                data: {
                    rating: this.rating,
                    review_text: this.reviewText
                }
            });

            this.resetForm();
        }
    },
    watch: {
        dialog(newVal) {
            if (!newVal) {
                this.resetForm();
            }
        }
    }
}
</script>

<style scoped>
.review-form-modal {
    position: relative;
}
</style>
